// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loading-container[data-v-bd9f9606]{margin-top:25px}.account-help-text[data-v-bd9f9606]{float:right;font-size:13px;margin-bottom:0}.access-link[data-v-bd9f9606]{font-weight:700}.tab-btn[data-v-bd9f9606]{border-width:.25px;border-color:#dee2e6;border-bottom-width:0;border-radius:0}.btn[data-v-bd9f9606]{font-size:small}.tab.active[data-v-bd9f9606]{background-color:#5f60ff;color:#fff}.nav-item[data-v-bd9f9606]{padding:0}", ""]);
// Exports
module.exports = exports;
